import {
    allVariants,
    collection,
    parentTypeFor,
    routePath,
} from "../_variants/index.js";
import { makeConcessionAttachable } from "../Concessions/attachable.js";
import { makeDQNAttachable } from "../DQNs/attachable.js";
import { makeDocumentsAttachable } from "../Documents/attachable.js";
import { makeDrawingAttachable } from "../Drawings/attachable.js";
import { makeServiceBulletinAttachable } from "../ServiceBulletins/attachable.js";
import {
    thirdPartyDocs,
    thirdPartyDraws,
    thirdPartyOther
} from "../Miscellaneous/attachable.js";

import ItemListView from "../../../components/ItemListView/ItemListView.vue"
import ItemView from "../../../components/ItemView/ItemView.vue"
import effectivitiesAttachable from "../Effectivities/attachable.js";

const dataFields = [{
    "label": "Number",
    "key": "Number"
}, {
    "label": "Parent",
    "key": "Parent",
    "link": "Database/:ParentType/:ParentID"
}, {
    "label": "Date Issued",
    "key": "Date.Issued",
    "type": "date"
}, {
    "label": "Type",
    "key": "Type"
}, {
    "label": "POA/Arrangement",
    "key": "To"
}, {
    "label": "MDL Revision",
    "key": "MDL.Revision"
}];

/**
 * Build the list + detail vue-router routes for the SADD register matching
 * the supplied variant.
 *
 * @param {import("../_variants/index.js").Variant} variant
 */
export const makeSADDRoutes = (variant) => {
    const isMilitary = variant.key === "military";
    const labelSingular = isMilitary ? "Military SADD" : "SADD";
    const labelPlural = isMilitary ? "Military SADDs" : "SADDs";
    const saddParentType = parentTypeFor(variant, "SADDs");
    const saddCollection = collection(variant, "SADDs");
    const listPath = routePath(variant, "SADDs");

    return [{
        "path": listPath,
        "component": {...ItemListView},
        "name": labelPlural,
        "meta": {
            "app": variant.app,
            "name": labelPlural,
            "sideNav": true,
            "sideNavSection": "Design Items",
            "appSwitcher": false,
            "icon": variant.appIcon,
            "tableSettings": saddParentType,
            "dataPath": saddCollection,
            "selectionRoute": `Database/${saddParentType}/{ID}`
        }
    }, {
        "path": `${listPath}/:id`,
        "component": ItemView,
        "name": labelSingular,
        "meta": {
            "app": variant.app,
            "name": labelPlural,
            "dataPath": saddCollection,
            "selectionRoute": `Database/${saddParentType}/{ID}`,
            title(item) {
                return `${labelPlural}: ${item.Number}`
            },
            "attachedItems": {
                "Attached Items": {
                    "attachables": [
                        makeDocumentsAttachable(variant),
                        makeDrawingAttachable(variant),
                        effectivitiesAttachable,
                        makeDQNAttachable(variant),
                        makeConcessionAttachable(variant),
                        makeServiceBulletinAttachable(variant),
                        thirdPartyDocs,
                        thirdPartyDraws,
                        thirdPartyOther
                    ]
                }
            },
            "preventAttachedItemsActions": false,
            "preventAttachedItemsRowActions": false,
            "dataFields": dataFields,
            "menuActions": [],
            "formMetadata": {
                "ParentType": saddParentType
            }
        }
    }];
};

export default allVariants().flatMap(makeSADDRoutes);
